/**
 * TransformItemDataByDefault Handler для Table
 * 
 * Трансформує дані елементів для коректного відображення в таблиці
 */

import { CheckNodeHelperTask } from '@/Core/Tasks/Utils/CheckNodeHelperTask'
import { transformFieldValue } from '../../utils'

/**
 * Трансформує дані елементів таблиці
 * 
 * @param params - об'єкт з параметрами
 * @param params.item - елемент dataSource
 * @param params.tableContext - контекст таблиці
 */
export const TransformItemDataByDefault = ({ item, tableContext }: { item: any, tableContext: any }) => {
    const crudContext = tableContext.storages?.crudContext
    const defaultLayoutContext = tableContext.storages?.defaultLayoutContext
    
    Object.keys(item).forEach((key) => {
        // Пропускаємо поля що не потрібно трансформувати
        if (
            (typeof tableContext.props.dataSourceNoTransform === 'boolean' &&
                tableContext.props.dataSourceNoTransform === true) ||
            (Array.isArray(tableContext.props.dataSourceNoTransform) &&
                tableContext.props.dataSourceNoTransform.includes(key)) ||
            key === '_original' ||
            key === '_actions' ||
            key === '_permissions'
        ) {
            return
        }
        
        // Пропускаємо поля що не входять в showColumns
        if (
            Array.isArray(tableContext.props.showColumns) &&
            tableContext.props.showColumns.length > 0 &&
            !tableContext.props.showColumns.includes(key)
        ) {
            return
        }
        
        const field = crudContext?.resource?.fields?.[key]

        // Трансформація через field definition
        if (field && item[key] !== undefined && item[key] !== null && item[key] !== '') {
            if (!Array.isArray(item[key])) {
                item[key] = transformFieldValue({
                    field,
                    value: item[key],
                    defaultLayoutContext,
                    item,
                    crudContext,
                    tableContext,
                })
            } else {
                // Трансформуємо кожен елемент масиву
                const transformedValues = item[key].map((value: any) =>
                    transformFieldValue({
                        field,
                        value,
                        defaultLayoutContext,
                        item,
                        crudContext,
                        tableContext,
                    })
                )
                
                // Для файлів не об'єднуємо в строку, щоб зберегти React компоненти
                if (field.type === 'file') {
                    // Показуємо тільки перший файл або всі в залежності від потреби
                    item[key] = transformedValues.length > 0 ? transformedValues[0] : '-'
                } else {
                    // Для інших типів об'єднуємо в строку
                    item[key] = transformedValues.join(', ')
                }
            }
            return
        }

        // Трансформація об'єктів без field definition
        if (item[key] !== undefined && item[key] !== null && item[key] !== '') {
            if (!Array.isArray(item[key])) {
                if (typeof item[key] === 'object' && !CheckNodeHelperTask.isElement(item[key])) {
                    if (item[key]?.fullName !== undefined)
                        item[key] = item[key].fullName
                    else if (item[key]?.lastName !== undefined)
                        item[key] = `${item[key].lastName ?? ''} ${item[key].firstName ?? ''}`
                    else if (item[key]?.title !== undefined) item[key] = item[key].title
                    else if (item[key]?.name !== undefined) item[key] = item[key].name
                    else item[key] = '-'
                }
            } else if (Array.isArray(item[key])) {
                const result: string[] = []
                item[key].forEach((value: any) => {
                    if (typeof value === 'object' && !CheckNodeHelperTask.isElement(value)) {
                        if (value?.fullName !== undefined)
                            result.push(value.fullName)
                        else if (value?.lastName !== undefined)
                            result.push(`${value.lastName ?? ''} ${value.firstName ?? ''}`)
                        else if (value?.title !== undefined) result.push(value.title)
                        else if (value?.name !== undefined) result.push(value.name)
                        else result.push('-')
                    } else {
                        result.push(String(value))
                    }
                })
                item[key] = result.join(', ')
            }
        }
    })
}
